import { REQUEST_STATUS } from '@/constants/request-status'

export function getRequestStatusById(id?: string) {
  return Object.values(REQUEST_STATUS).find((obj) => obj.id === id)
}
